import { createApp } from 'vue'
import { createPinia } from 'pinia'
import * as Sentry from '@sentry/vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import './assets/main.css'
import 'highlight.js/styles/atom-one-dark.css'

// Create app first
const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)
app.use(i18n)

// Sentry — solo captura de errores (sin performance/replay, coste 0).
// Solo en builds de producción y si el DSN llega horneado (VITE_SENTRY_DSN);
// el default del Dockerfile apunta al Sentry de prod y no debe recibir dev.
if (import.meta.env.PROD && import.meta.env.VITE_SENTRY_DSN) {
  try {
    Sentry.init({
      app,
      dsn: import.meta.env.VITE_SENTRY_DSN,
      environment: import.meta.env.MODE,
      tracesSampleRate: 0,
    })
    // Contexto de ruta en cada error (1 línea, sin tracing).
    router.afterEach((to) => Sentry.setTag('route', to.name || to.path))
  } catch {
    // Sentry jamás debe impedir el montaje de la app.
  }
}

// Service worker huérfano: la PWA se retiró, pero navegadores con la app ya
// instalada siguen sirviendo el bundle viejo desde el SW cacheado. Lo
// desregistramos en cada arranque; en cuanto no queden registros esto es un no-op.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .getRegistrations()
    .then(rs => rs.forEach(r => r.unregister()))
    .catch(() => {
      // Contextos inseguros o SW deshabilitado: nada que limpiar.
    })
}

// Mount the app (después de init para capturar errores tempranos de montaje)
app.mount('#app')

// Initialize dark mode (non-blocking, with error handling)
import { useUIStore } from '@/stores/ui'
const uiStore = useUIStore()
try {
  uiStore.initializeDarkMode()
} catch (error) {
  console.error('Dark mode initialization failed:', error)
}
